const timeline = [
  {
    period: "Current",
    role: "Police CyberAlarm Lead",
    org: "NPCC National Cyber Crime Team",
    description: "Leading Police CyberAlarm, a Home Office funded national cyber security initiative delivered through UK policing. Focused on growing CyberAlarm into a trusted national policing brand, increasing membership, strengthening sector partnerships and ensuring the service delivers genuine value to both businesses and the policing network.",
    highlights: [
      "Passive monitoring of suspicious external activity for UK businesses",
      "Real-time insight into malware trends and compromise indicators",
      "Intelligence supporting prevention, protection and disruption",
    ],
  },
  {
    period: "Previous",
    role: "CEO",
    org: "National Cyber Resilience Centre Group",
    description: "Established and led a nationally coordinated programme designed to protect UK SMEs through unique police-private-academic partnerships.",
    highlights: [
      "Established Regional Cyber Resilience Centre network across England and Wales",
      "Launched National Ambassador Programme with leading private sector organisations",
      "Created Cyber PATH programme for affordable SME cyber services",
    ],
  },
  {
    period: "2017-2020",
    role: "Head of Cyber, Digital Forensics & Economic Crime",
    org: "South East Regional Organised Crime Unit (SEROCU)",
    description: "Led regional capabilities tackling serious and organised cyber-enabled crime. Senior Investigating Officer on complex cyber and cryptocurrency investigations.",
    highlights: [
      "Authored national guidance for cryptocurrency seizure under POCA",
      "Member of Home Office Cryptocurrency Working Group",
      "Technical Manager achieving ISO 17025 accreditation for digital forensics",
      "Led national police programme for ISO 17020 accreditation",
    ],
  },
  {
    period: "1993-2023",
    role: "A 30-year policing career, progressing through all ranks to Detective Superintendent",
    org: "Various Forces and NPCC National Cybercrime Programme",
    description: "30 years in policing as a career detective and senior leader, specialising in cybercrime, economic crime, digital forensics and financial investigation.",
    highlights: [
      "Senior Investigating Officer on major fraud and organised crime",
      "National lead for digital forensics standards and accreditation",
      "Combined operational delivery with national strategy and governance",
    ],
  },
]

export function Experience() {
  return (
    <section id="experience" className="py-24 lg:py-32 bg-card border-t border-border/30">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="grid lg:grid-cols-12 gap-16">
          {/* Left column - Header */}
          <div className="lg:col-span-4 lg:sticky lg:top-32 lg:self-start">
            <div className="flex items-center gap-4 mb-6">
              <div className="w-12 h-px bg-primary" />
              <span className="text-xs tracking-[0.3em] uppercase text-muted-foreground font-medium">
                Career
              </span>
            </div>
            <h2 className="font-serif text-3xl sm:text-4xl lg:text-5xl leading-tight mb-6">
              Three decades of leadership
            </h2>
            <p className="text-muted-foreground text-lg leading-relaxed">
              A career operating at the intersection of cyber risk, economic crime,
              public trust and organisational growth, from frontline investigation
              to national programme delivery and executive roles.
            </p>
          </div>

          {/* Right column - Timeline */}
          <div className="lg:col-span-8">
            <div className="space-y-0">
              {timeline.map((item) => (
                <div
                  key={item.role}
                  className="group relative pl-8 pb-12 last:pb-0 border-l border-border/50 hover:border-primary/50 transition-colors duration-300"
                >
                  {/* Timeline dot */}
                  <div className="absolute left-0 top-0 -translate-x-1/2 w-3 h-3 border-2 border-border bg-background group-hover:border-primary group-hover:bg-primary/20 transition-colors duration-300" />

                  {/* Content */}
                  <div className="space-y-3">
                    <span className="text-xs tracking-widest text-muted-foreground font-medium">
                      {item.period}
                    </span>
                    <h3 className="font-serif text-xl lg:text-2xl text-foreground">
                      {item.role}
                    </h3>
                    <span className="inline-block text-sm text-primary tracking-wide">
                      {item.org}
                    </span>
                    <p className="text-muted-foreground leading-relaxed pt-2 text-sm">
                      {item.description}
                    </p>
                    {item.highlights && (
                      <ul className="pt-4 space-y-2">
                        {item.highlights.map((highlight, index) => (
                          <li key={index} className="flex items-start gap-3 text-sm text-muted-foreground">
                            <span className="text-primary mt-1.5 text-xs">&#9642;</span>
                            {highlight}
                          </li>
                        ))}
                      </ul>
                    )}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}
